module.exports = __webpack_public_path__ + "static/media/KGZ.1bfc8816.png";